import { useState, useCallback } from "react";
export var useFocusedState = function (_a) {
    var _b = _a.defaultState, defaultState = _b === void 0 ? false : _b, onBlur = _a.onBlur, onFocus = _a.onFocus;
    var _c = useState(defaultState), focused = _c[0], setFocused = _c[1];
    var handleFocus = useCallback(function (e) {
        if (!focused) {
            setFocused(true);
        }
        if (onFocus) {
            onFocus(e);
        }
    }, [onFocus, focused]);
    var handleBlur = useCallback(function (e) {
        setFocused(false);
        if (onBlur) {
            onBlur(e);
        }
    }, [onBlur]);
    return [focused, handleFocus, handleBlur];
};
